<div class="bank-account-body" fxLayoutAdivgn="center center">
  <div class="bank-account-form-wrapper">
    <div id="bank-account-form">
      <form name="parentForm" [formGroup]="parentForm">
        <mat-form-field *ngIf="!isAddNewAccount else newaccount" class="used-account" appearance="outline">
          <mat-label i18n>select account</mat-label>
          <select matNativeControl name="used-account" formControlName="used_account">
            <option *ngFor="let item of savedAccounts; let first=first" [attr.selected]='first ? "selected" : null' [value]="item.value">{{ item.display_name }}
            </option>
          </select>
          <mat-error *ngIf="parentForm.get('used_account')?.errors?.serverError">
            {{ parentForm.get('used_account').errors?.serverError }}
          </mat-error>
        </mat-form-field>
        <div *ngIf="!isAddNewAccount" clsss="add-account" fxLayout="column" fxLayoutAlign="center center">
          <button mat-stroked-button color="primary" style="text-transform: capitalize;" (click)="setIsAddNewAccount(true)" i18n>add new account</button>
        </div>
        <ng-template #newaccount>
          <div fxLayout="column" fxLayoutAlign="center center">
            <mat-form-field appearance="outline">
              <mat-label i18n>bank name</mat-label>
              <input trim matInput type="text" formControlName="bank_name" cdkFocusInitial>
              <mat-error *ngIf="parentForm.get('bank_name')?.hasError('required')" i18n>Please provide your bank name.</mat-error>
              <mat-error *ngIf="parentForm.get('payee')?.errors?.serverError">
                {{ parentForm.get('payee').errors?.serverError }}
              </mat-error>
            </mat-form-field>
          </div>
          <div fxLayout="column" fxLayoutAlign="center center">
            <mat-form-field class="swift" appearance="outline">
              <mat-label i18n>swift code</mat-label>
              <input trim matInput type="text" formControlName="swift_code">
              <mat-error *ngIf="parentForm.get('swift_code')?.errors?.serverError">
                {{ parentForm.get('swift_code').errors?.serverError }}
              </mat-error>
            </mat-form-field>
          </div>
          <div fxLayout="column" fxLayoutAlign="center center">
            <mat-form-field class="payee" appearance="outline">
              <mat-label i18n>name and surname</mat-label>
              <input trim matInput type="text" placeholder="payee" formControlName="payee">
              <mat-error *ngIf="parentForm.get('payee')?.hasError('required')" i18n>Please provide your details.</mat-error>
              <mat-error *ngIf="parentForm.get('payee')?.errors?.serverError">
                {{ parentForm.get('payee').errors?.serverError }}
              </mat-error>
            </mat-form-field>
          </div>
          <div fxLayout="column" fxLayoutAlign="center center">
            <mat-form-field appearance="outline">
              <mat-label i18n>IBAN number</mat-label>
              <input trim matInput type="text" formControlName="iban_account_number" cdkFocusInitial>
              <mat-error *ngIf="parentForm.get('iban_account_number')?.hasError('required')" i18n>Please provide IBAN.</mat-error>
              <mat-error *ngIf="parentForm.get('iban_account_number')?.errors?.serverError">
                {{ parentForm.get('iban_account_number').errors?.serverError }}
              </mat-error>
            </mat-form-field>
          </div>
          <mat-form-field class="country" appearance="outline">
            <mat-label i18n>select country</mat-label>
            <select matNativeControl name="country" formControlName="country">
              <option *ngFor="let country of countries" [value]="country.value">{{ country.display }}
              </option>
            </select>
            <mat-error *ngIf="parentForm.get('country')?.errors?.serverError">
              {{ parentForm.get('country').errors?.serverError }}
            </mat-error>
          </mat-form-field>

          <div fxLayout="row" fxLayoutAlign="center center">
            <section class="accept-terms">
              <mat-checkbox formControlName="iban_account_number_confirm" i18n>I confirm that the account belongs to me.</mat-checkbox>
            </section>
          </div>
        </ng-template>
      </form>
    </div>
  </div>
</div>